module.exports = __webpack_public_path__ + "static/9-4b19049d853b319220691b8cd0d2697a.jpg";